import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql, navigate } from "gatsby"

const BrandContainer = styled.div`
  background-color: #fff;
  width: 100%;
`

const FeaturedBrands = styled.div`
  max-width: 140rem;
  margin: auto;
  padding: 2rem 1.4rem 1.6rem 1.4rem;
  @media (min-width: 768px) {
    padding: ${props => props.isHeader ? "0rem 2rem .4rem 2rem" : "4.8rem 3rem 6rem 3rem"};
  }
  @media (min-width: 1280px) {
    padding: ${props => props.isHeader ? "0" : "4.8rem 3.6rem 6rem 3.6rem"};
  }
`

const FeaturedLabel = styled.div`
  font-size: 1.8rem;
  font-weight: 600;
  margin-top: 0.8rem;
  margin-bottom: 1.6rem;
  color: #333;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
  @media (min-width: 961px) {
    font-size: 2rem;
  }
  @media (min-width: 1280px) {
    font-size: 2.2rem;
  }
  user-select: none;
`

const BrandInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`

const BrandItem = styled.div`
  width: 33%;
  padding: 0rem 1rem;
  cursor: pointer;
  @media (min-width: 768px) {
    width: 20%;
  }
`

const BrandImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: ${props => (props.isHeader ? "10rem" : "100%")};
  object-fit: contain;
`

const FeaturedBrandsRow = props => {
  const { isHeader } = props
  const category = useStaticQuery(graphql`
    query HomeBrands {
      estore {
        getHomepageBrands(limit: 10, isFeatured: true) {
          _id
          name
          image
          order
        }
      }
    }
  `)

  const featuredBrands =
    category.estore.getHomepageBrands != null
      ? category.estore.getHomepageBrands.filter(brand => brand.image !== null)
      : []

  featuredBrands.length = Math.min(featuredBrands.length, 5)

  return (
    featuredBrands.length > 1 && (
      <BrandContainer>
        <FeaturedBrands isHeader={isHeader}>
          {!isHeader && <FeaturedLabel>Featured Brands</FeaturedLabel>}
          <BrandInnerContainer>
            {featuredBrands.map((brand, index) => {
              return (
                <BrandItem
                  key={index}
                  onClick={() => {
                    sessionStorage.removeItem(`${brand.name}::scrollTo`)
                    navigate("/brand/" + brand.name)
                  }}
                >
                  <BrandImage isHeader={props.isHeader} src={brand.image} />
                </BrandItem>
              )
            })}
          </BrandInnerContainer>
        </FeaturedBrands>
      </BrandContainer>
    )
  )
}

export default FeaturedBrandsRow
